import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Rate } from 'hljd'
import ImgBox from '@common/ImgBox'
import styles from './style.module.less'
import store from '../store'
import twemoji from 'twemoji'
import { getObjValue, replaceEmojiToImg } from '@hlj/hlj-utils'
import cls from 'classnames'

@observer
export default class extends Component {
  componentDidMount() {
    store.getAppealInfo()
  }

  render() {
    const {
      appeal_status,
      created_at,
      content,
      reason,
      photos,
      community_comment,
      order_comment,
      qa_answer,
      qa_question,
      kind
    } = store
    let isComment = order_comment && order_comment.id //是否为评价节点
    let twemojiContent = isComment
      ? order_comment.content || ''
      : community_comment.content || ''

    let qa_detail = qa_answer && qa_answer.id ? qa_answer : qa_question
    let qa_content =
      qa_answer && qa_answer.id
        ? getObjValue(qa_answer, 'content')
        : getObjValue(qa_question, 'title')
    let reason_question = ''
    switch (Number(reason)) {
      case 1:
        reason_question = '恶意诋毁'
        break
      case 2:
        reason_question = '广告'
        break
      case 3:
        reason_question = '色情'
        break
      case 4:
        reason_question = '辱骂脏话'
        break
      case 5:
        reason_question = '其他'
        break
    }
    return (
      <div className={styles.resultWrap}>
        <div className={styles.result}>
          <p>{appeal_status == 1 ? '申述成功' : '申述失败'}</p>
          <ul>
            <li>
              <span>申诉时间：</span>
              <span>{created_at}</span>
            </li>
            <li>
              <span>申诉结果：</span>
              <span>
                {appeal_status == 1
                  ? '经核实该评价存在违规行为，已做隐藏处理，感谢您对婚礼纪的贡献与支持'
                  : '根据您提供的申诉描述经核实未发现该评价存在违规行为，感谢您对婚礼纪的贡献与支持'}
              </span>
            </li>
          </ul>
        </div>
        <ul className={styles.resultDetail}>
          <li>
            <p className={styles.left}>申诉理由：</p>
            <div className={styles.right}>{reason_question}</div>
          </li>
          <li>
            <p className={styles.left}>理由描述：</p>
            <div className={styles.right}>{content}</div>
          </li>
          <li>
            <p className={styles.left}>图片凭证：</p>
            <div className={styles.right}>
              {photos.length > 0 ? (
                <ImgBox
                  imgs={photos}
                  keyField="image_path"
                  style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    justifyContent: 'flex-start',
                    marginBottom: 15
                  }}
                  suffix={'imageView2/1/w/150/h/150'}
                  preSuffix={'imageView2/2/w/530/h/320'}
                />
              ) : (
                '未添加图片描述'
              )}
            </div>
          </li>
        </ul>
        <div className={styles.content}>
          <p className={styles.title}>申诉内容：</p>
          {kind == 'question' ? (
            <div className={styles.item}>
              <div>
                <p
                  className={cls({
                    [styles.question]: true,
                    [styles.answer]: qa_answer && qa_answer.id
                  })}
                >
                  {qa_content}
                </p>
                <p className={styles.answer}>
                  <span>{getObjValue(qa_detail, 'user.nick')}</span>
                  <span>{created_at}</span>
                </p>
              </div>
            </div>
          ) : (
            <div style={{ padding: '0px 20px' }}>
              <p className={styles.nameWrap}>
                <span className={styles.name}>
                  {isComment
                    ? getObjValue(order_comment, 'author.nick') || ''
                    : getObjValue(community_comment, 'user.nick') || ''}
                </span>
                <span className={styles.time}>
                  {isComment
                    ? getObjValue(order_comment, 'created_at') || ''
                    : getObjValue(community_comment, 'created_at') || ''}
                </span>
              </p>
              <p
                className={styles.comment}
                dangerouslySetInnerHTML={{
                  __html: twemoji.parse(replaceEmojiToImg(twemojiContent))
                }}
              />
              {isComment && (
                <div className={styles.imgWrap}>
                  <ImgBox
                    imgs={order_comment.comment_photos || []}
                    keyField="photo_path"
                    style={{
                      display: 'flex',
                      justifyContent: 'flex-start',
                      width: 500,
                      marginBottom: 15
                    }}
                    suffix={'imageView2/1/w/80/h/80'}
                  />
                  <div>
                    <Rate value={+order_comment.rating} disabled />
                    <i className={styles.out}>
                      {+order_comment.rating == 1
                        ? '不好'
                        : +order_comment.rating == 2
                          ? '一般'
                          : +order_comment.rating == 3
                            ? '基本满意'
                            : +order_comment.rating == 4
                              ? '很满意'
                              : +order_comment.rating == 5
                                ? '超出预期'
                                : ''}
                    </i>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    )
  }
}
